import { mapEnum } from "../../utils/mapEnum"

const ICON_SIZE = ['small', 'default', 'medium', 'large', 'xl']

const ICON_SIZE_OBJECT = mapEnum(ICON_SIZE)

const ICON_SIZE_MAPPING = {
    [ICON_SIZE_OBJECT.SMALL]: '16px',
    [ICON_SIZE_OBJECT.DEFAULT]: '24px',
    [ICON_SIZE_OBJECT.MEDIUM]: '32px',
    [ICON_SIZE_OBJECT.LARGE]: '48px',
    [ICON_SIZE_OBJECT.XL]: '60px'
}

interface IconClassToPathMapping {
    'icon-tfw-amex': string[];
    'icon-tfw-discover': string[];
    'icon-tfw-facebook-colored': string[];
    'icon-tfw-insta': string[];
    'icon-tfw-insta-colored': string[];
    'icon-tfw-linkedin-colored': string[];
    'icon-tfw-mastercard': string[];
    'icon-tfw-toggle-off': string[];
    'icon-tfw-toggle-on': string[];
    [key: string]: string[]; // Add an index signature
  }


const ICON_CLASS_TO_PATH_MAPPING: IconClassToPathMapping = {
    'icon-tfw-amex': ['path1', 'path2', 'path3', 'path4', 'path5', 'path6', 'path7', 'path8'],
    'icon-tfw-discover': ['path1', 'path2', 'path3', 'path4', 'path5', 'path6', 'path7', 'path8', 'path9'],
    'icon-tfw-facebook-colored': ['path1', 'path2'],
    'icon-tfw-insta': ['path1', 'path2', 'path3', 'path4'],
    'icon-tfw-insta-colored': ['path1', 'path2', 'path3', 'path4'],
    'icon-tfw-linkedin-colored': ['path1', 'path2', 'path3', 'path4'],
    'icon-tfw-mastercard': ['path1', 'path2', 'path3', 'path4'],
    'icon-tfw-toggle-off': ['path1', 'path2', 'path3'],
    'icon-tfw-toggle-on': ['path1', 'path2'],
}

export { ICON_SIZE_MAPPING, ICON_SIZE , ICON_CLASS_TO_PATH_MAPPING }
